/**
 * Level Funded proposal body. Field names match centivo-business/proposal.json.
 * Persistence is localStorage for now; this body will move to the DynamoDB Proposal table.
 */

export const PLAN_KEYS = [
    "centivoPartnershipPlan",
    "centivoHDHPPlan",
    "traditionalPPOPlan",
    "traditionalHDHPPlan",
];

export const TIER_KEYS = ["eeOnly", "eeSp", "eeCh", "family"];

export const PLAN_FIELD_KEYS = [
    "typicalAV(accounts for HRA/HSA)",
    "planAdministrator",
    "network",
    "oonEEOnly-ded/oopm/coins",
    "virtualPrimaryCare",
    "pcp&ReferralsRequired",
    "deductible",
    "outOfPocketMax",
    "pcpVisits",
    "specialists",
    "basicLabs/imaging",
    "outpatientSurgery",
    "inpatientSurgery",
    "urgentCare",
    "emergencyRoom",
    "rx",
];

const RATE_FIELDS = [
    "enrollment",
    "fixedCost",
    "medicalAccoont",
    "billedMaxCount",
    "premiumEquivalent",
];

const LF_RATE_FIELDS = [
    "enrollment",
    "ratesAt100% (Expected)",
    "ratesAt110% (Mid-Low)",
    "ratesAt115% (Mid-High)",
    "ratesAt115% (Max)",
];

function blankFields(keys) {
    return Object.fromEntries(keys.map((key) => [key, ""]));
}

function plansOf(fields) {
    return Object.fromEntries(PLAN_KEYS.map((plan) => [plan, blankFields(fields)]));
}

function tiersOf(fields) {
    return Object.fromEntries(TIER_KEYS.map((tier) => [tier, blankFields(fields)]));
}

export function emptyProposalData() {
    return {
        planDesign: plansOf(PLAN_FIELD_KEYS),
        costComparisionOverview: {
            statusQuo: {
                totalSpend: {
                    current: "",
                    "renewal30%": "",
                },
            },
            centivoClaimsAndSurplus: {
                totalSpend: {
                    "80%": "",
                    "90%": "",
                    "100% (Expected)": "",
                    "125% (Billed Max)": "",
                },
            },
            centivoVsStatusQuo: {
                "vsCurrent($)": ["", "", "", ""],
                "vsCurrent(%)": ["", "", "", ""],
                "vsRenewal($)": ["", "", "", ""],
                "vsRenewal(%)": ["", "", "", ""],
            },
            notes: [],
        },
        stoploss: {
            carrier: "",
            effectiveDate: "",
            contract: "",
            deductible: "",
            brokerComp: "",
            proposalExpiration: "",
        },
        totalCostOfCareSaving: {
            fullyInsured: blankFields(["renewal", "year2", "year3", "year4", "year5", "5YearsCumulativeSpend"]),
            centivoMaxCosts: blankFields(["renewal", "year2", "year3", "year4", "year5", "5YearsCumulativeSpend"]),
            centivoExpectedCost: blankFields(["renewal", "year2", "year3", "year4", "year5", "5YearsCumulativeSpend"]),
            totalExpected5YearsSavings: "",
            employerExpected5YearSavings: "",
            employeeExpected5YearsSaving: "",
        },
        rates: Object.fromEntries(PLAN_KEYS.map((plan) => [plan, tiersOf(RATE_FIELDS)])),
        ratesWithWriteWise: {
            ...Object.fromEntries(PLAN_KEYS.map((plan) => [plan, tiersOf(RATE_FIELDS)])),
            writeWiseRx: {
                totalMembers: "",
                billedMaxCosts: "",
            },
            notes: [],
        },
        lfRateTable: {
            ...Object.fromEntries(PLAN_KEYS.map((plan) => [plan, tiersOf(LF_RATE_FIELDS)])),
            stoplossContract: {
                carrier: "",
                contractType: "",
                specificDeductible: "",
                aggregateCorridor: "",
            },
            notes: [],
        },
        asoOption: {
            notes: [],
        },
    };
}

export function sectionHasValues(value) {
    if (Array.isArray(value)) return value.some((item) => sectionHasValues(item));
    if (value && typeof value === "object") {
        return Object.entries(value).some(([key, child]) => {
            if (key === "isTitle" || key === "isSubTitle") return false;
            return sectionHasValues(child);
        });
    }
    return value !== "" && value != null;
}
